@if (loading())
{
    <lib-frontend-spinner/>
}
@else
{
    @if (url() === '' || url() === undefined) 
    {
        <h1 class="card-title">Zahlung fehlgeschlagen</h1>
        <p>
            <a class="btn btn-primary" [href]="backUrl()">zur Übersicht</a>
        </p>
    } 
    @else 
    {
        @if (showAmazonRedirect())
        {
            Sie werden jetzt noch einmal an Amazon zur Verifizierung der Zahlung weitergeleitet.
            <a href="{{url()}}">direkt öffnet</a> 
        }
        @else
        {
            <lib-frontend-spinner/>
        }
    }
}